import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { StyledEngineProvider } from '@mui/material';
import { PostHogProvider } from 'posthog-js/react';
import App from './App';
import store from './store';
import './index.css';
import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById('root');

const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
};

const posthogApiKey = process.env.REACT_APP_POSTHOG_KEY;

const baseComponent = (
  <React.StrictMode>
    {posthogApiKey ? (
      <PostHogProvider apiKey={posthogApiKey} options={posthogOptions}>
        <Provider store={store}>
          <StyledEngineProvider injectFirst>
            <App />
          </StyledEngineProvider>
        </Provider>
      </PostHogProvider>
    ) : (
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <App />
        </StyledEngineProvider>
      </Provider>
    )}
  </React.StrictMode>
);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(baseComponent, rootElement);
} else {
  ReactDOM.render(baseComponent, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
